import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getEnvUrl } from "../../utils/Api";
import profilepic from "../../assets/icons/profilepic.png";
// import basicpackage from "../../assets/icons/basicpackage.png";
// import premiumpackage from "../../assets/icons/premiumpackage.png";
// import advancedpackage from "../../assets/icons/advancedpackage.png";
import logout from "../../assets/icons/logout.png"
import "./Profile.css";
import {
  daysDifference,
  shortMonths,
  validateEmail,
  validateUserName,
  getDateFullMonthFormat,
  logoutUser,
} from "../../utils/Common";
import { useState } from "react";
import {
  EditUser,
  EditUserAddress,
  PincodeData,
  SetDefaultPincodeData,
  UserAddress,
  ShowToastMessage
} from "../../redux/actions";

// const backgroundColors = {
//   1: "linear-gradient(rgb(247 148 32 / 24%) 0%, rgb(16, 16, 16) 100%)",
//   2: "linear-gradient(rgb(220 28 80 / 23%) 0%, rgb(16, 16, 16) 100%)",
//   3: "linear-gradient(rgb(107 203 225 / 13%) 0%, rgb(16, 16, 16) 100%)",
// };

function addGradientToColor(background_color) {
  return `linear-gradient(135deg, ${background_color}, #0D0D0E)`;
}

var timestamp = new Date().getTime();

export default function Userprofile() {
  const initialAddress = {
    pincode: "",
    state_id: "",
    city: "",
    address: "",
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isEditVisible, setIsEditVisible] = useState(false);
  const [editUserName, setEditUserName] = useState("");
  const [editUserEmail, setEditUserEmail] = useState("");
  const [isError, setIsError] = useState("");
  const [isEditAddress, setIsEditAddress] = useState(false);
  const [isAddressError, setIsAddressError] = useState("");
  const [userAddress, setuserAddress] = useState(initialAddress);
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);
  const [showLogoutToast, setShowLogoutToast] = useState(false);
  const { display_name, mobile_number, email, country_code, address } = useSelector(
    (state) => state.userStore.userProfileData
  );
  const { statesList, pincodeData, userAddressData } = useSelector(
    (state) => state.userStore
  );
  console.log("userAddressData", userAddressData);
  const { subscriptionPlanListData, mySubscriptionData } = useSelector(
    (state) => state.subscriptionStore
  );
  console.log(subscriptionPlanListData);
  const getSubscriptionPlanData = subscriptionPlanListData?.filter(
    (plan) => mySubscriptionData.plan_id === plan.id
  )[0];


  useEffect(() => {
    dispatch(UserAddress());
  }, []);
  useEffect(() => {
    setEditUserName(display_name);
    setEditUserEmail(email);
  }, [display_name, email]);
  useEffect(() => {
    if (pincodeData) {
      setuserAddress({
        ...userAddress,
        state_id: pincodeData?.state_id ? pincodeData?.state_id : "",
        city: pincodeData?.cityname ? pincodeData?.cityname[0] : "",
      });
    }
  }, [pincodeData]);
  useEffect(() => {
    if (userAddressData?.pincode) {
      dispatch(PincodeData({ pincode: userAddressData?.pincode }));
      setuserAddress({
        ...userAddress,
        pincode: userAddressData?.pincode ? userAddressData?.pincode : "",
        state_id: userAddressData?.state_id ? userAddressData?.state_id : "",
        city: userAddressData?.city ? userAddressData?.city : "",
        address: userAddressData?.address ? userAddressData?.address : "",
      });
    }
  }, [userAddressData])


  const getModifiedDate = (date) => {
    let objectDate = new Date(date);
    let day = objectDate.getDate();
    let month = objectDate.getMonth() + 1;
    let year = objectDate.getFullYear();
    return `${shortMonths[month]} ${day}, ${year}`;
  };
  const handleEditUser = () => {
    if (!validateUserName(editUserName)) {
      setIsError("Enter valid name");
      return;
    } else if (!validateEmail(editUserEmail)) {
      setIsError("Enter valid e-mail");
      return;
    }
    const editedUser = {
      name: editUserName,
      email: editUserEmail,
    };
    dispatch(EditUser(editedUser));
    setIsEditVisible(false);
  };

  const editUserProfile = () => {
    setEditUserName(display_name);
    setEditUserEmail(email);
    setIsEditVisible(true)
  }
  const getPincodeData = () => {
    if (userAddress?.pincode?.length === 6) {
      setIsAddressError("");
      dispatch(PincodeData({ pincode: userAddress.pincode }));
    } else {
      setIsAddressError("Please enter correct pincode");
    }
  };
  const handleEditAddress = () => {
    const { pincode, state_id, city, address } = userAddress;
    if (!pincode || !state_id || !city || !address) {
      setIsAddressError("Please enter all required fields.");
      return;
    }
    if (!address || address.length < 5 || address.length > 300) {
      setIsAddressError("Address must have between 5 and 300 characters.");
      return;
    } else {
      setIsAddressError("");
    }
    if (!pincode || !state_id || !city || !address) {
      if (!pincode) {
        setIsAddressError("Please enter pincode");
      } else if (pincode && pincode.length !== 6) {
        setIsAddressError("Please enter correct pincode");
      } else if (!state_id) {
        setIsAddressError("Please enter state");
      } else if (!city) {
        setIsAddressError("Please enter city");
      } else if (!address) {
        setIsAddressError("Please enter address");
      }
      return;
    }
    dispatch(EditUserAddress({ ...userAddress }));
    setIsEditAddress(false);
    setIsAddressError("");
    setuserAddress(initialAddress);
    dispatch(SetDefaultPincodeData());
  };
  const handleEditAddressClose = () => {
    setIsEditAddress(false);
    setIsAddressError("");
    // setuserAddress(initialAddress);
    dispatch(UserAddress());
    dispatch(SetDefaultPincodeData());
  };
  const confirmLogout = () => {
    setShowLogoutPopup(false);
    setShowLogoutToast(true);
    setTimeout(() => {
      logoutUser({ navigate });
    }, 500);
  };
  useEffect(() => {
    if (showLogoutPopup || showLogoutToast) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [showLogoutPopup, showLogoutToast]);
  return (
    <div className="Profile-main">
      <div className="Profile-details">
        <p className="Profile-heading-info">Profile</p>
        <div className="Profile-img-box-1">
          <div className="input-box">
            <div className="text-1">
              <span className="Phone-number-text">Name</span>
              <input
                className="Mobile-number-1"
                disabled
                value={display_name}
              />
            </div>
            <div className="text-1">
              <span className="Phone-number-text">Email</span>
              <input
                className="Mobile-number-1"
                disabled
                value={email}
              />
            </div>
            <div className="text-1">
              <span className="Phone-number-text">Phone Number</span>
              <input
                className="Mobile-number-1"
                disabled
                value={mobile_number}
              />
            </div>
            { userAddressData?.address && (
            <div className="text-1">
              <span className="Phone-number-text">Address</span>
              <textarea rows="5" cols="30" className="Mobile-number-1" disabled>
                {userAddressData?.address || ""}
              </textarea>
            </div>
            )}
          </div>
        </div>
      </div>
      {/* <div className="Profile-details">
        <p className="Profile-heading-info">Contact US</p>
        <div className="Profile-img-box-1">
          <div className="input-box">
            <div className="text-1">
              <span className="Phone-number-text">Email</span>
              <input
                className="Mobile-number-1"
                disabled
                value="contact@magikmat.com"
              />
            </div>
            <div className="text-1">
              <span className="Phone-number-text">Phone Number</span>
              <input
                className="Mobile-number-1"
                disabled
                value="+91 – 72004 72006​"
              />
            </div>
          </div>
        </div>
      </div> */}
      <div className="LogoutDiv">
        <button
          to="/"
          className="nav-logout-btn"
          onClick={() => setShowLogoutPopup(true)}
        >
          {/* <img src={logout} alt="logout" className="editimag" /> */}
          Logout
        </button>
      </div>
      {showLogoutPopup && (
        <div className="logout-popup-overlay">
          <div className="logout-popup">
            <p>Are you sure you want to logout?</p>

            <div className="logout-popup-buttons">

              <button
                className="logout-confirm"
                onClick={confirmLogout}
              >
                Yes
              </button>
              <button
                className="logout-cancel"
                onClick={() => setShowLogoutPopup(false)}
              >
                No
              </button>

            </div>
          </div>
        </div>
      )}
      {showLogoutToast && (
        <div className="logout-toast-overlay">
          <div className="logout-toast">
            <p className="logoutToastText" style={{ margin: 0 }}> Logged Out Successfully</p>
          </div>
        </div>
      )}
    </div>
  );
}
